'use client';

import { NavigationCarousel } from '@/features/carousel';
import { getCdnUrl } from '@/utils/url';
import { useLanguage } from '../../context/language-context-provider';
const ITEMS = [getCdnUrl('/_toad/images/about-us/gallery-1.png'), getCdnUrl('/_toad/images/about-us/gallery-2.png'), getCdnUrl('/_toad/images/about-us/gallery-3.png'), getCdnUrl('/_toad/images/about-us/gallery-4.png'), getCdnUrl('/_toad/images/about-us/gallery-5.png'), getCdnUrl('/_toad/images/about-us/gallery-6.png'), getCdnUrl('/_toad/images/about-us/gallery-7.png')];
const GalleryCarousel = () => {
  const {
    t,
    language
  } = useLanguage();
  return <div className='relative w-full overflow-hidden' data-sentry-component="GalleryCarousel" data-sentry-source-file="carousel.tsx">
            <NavigationCarousel options={{
      perView: 'auto',
      rtl: language === 'fa',
      mode: 'free',
      spacing: 12
    }} data-sentry-element="NavigationCarousel" data-sentry-source-file="carousel.tsx">
                {ITEMS.map((image, index) => <img key={index} width={237} height={158} alt={t('gallery')} src={image} className='keen-slider__slide h-[158px] min-h-[158px] w-[237px] min-w-[237px] max-w-max rounded-md border border-solid border-border-gray-light lg:h-[200px] lg:min-h-[200px] lg:w-[300px] lg:min-w-[300px] lg:rounded-lg' />)}
            </NavigationCarousel>
        </div>;
};
export default GalleryCarousel;